import { match } from 'ts-pattern';
export var CanvasTabs;
(function (CanvasTabs) {
    CanvasTabs["Preview"] = "preview";
    CanvasTabs["Source"] = "source";
})(CanvasTabs || (CanvasTabs = {}));
export function initCanvasState() {
    return {
        loading: false,
        activeTab: CanvasTabs.Preview,
        title: undefined,
        icon: undefined,
    };
}
export const canvasReducer = (state, action) => {
    return match(action)
        .with({ type: 'setLoading' }, ({ loading, assetType }) => ({
        ...state,
        loading,
        loadingAssetType: assetType,
    }))
        .with({ type: 'setAsset' }, ({ assetUuid, title, backendUuid, contextUuid, asset, assetContext }) => ({
        ...state,
        assetUuid,
        title,
        backendUuid,
        contextUuid,
        asset,
        assetContext: assetContext ?? state.assetContext,
    }))
        .with({ type: 'setTitle' }, ({ title, icon }) => ({
        ...state,
        title,
        icon,
    }))
        .with({ type: 'setTab' }, ({ tab }) => ({
        ...state,
        activeTab: tab,
    }))
        .exhaustive();
};
//# sourceMappingURL=canvasReducer.js.map